/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */
import { startCase } from 'lodash';
import { parseISO, format } from 'date-fns';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const DISPLAY_DATE_FORMAT = 'MM/dd/yyyy';

/**
 * Enum that represents the periods options that we support
 * @readonly
 * @enum {string}
 * DoesNotRepeat | Custom | Weekly | Monthly | Quarterly | Semiannually | Annually | Yearly
 */
export enum PeriodOptions {
  DoesNotRepeat = 'Does not repeat',
  Custom = 'Custom repeat',
  Weekly = 'WEEKLY',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Semiannually = 'SEMIANNUALLY',
  Annually = 'ANNUALLY',
  Yearly = 'YEARLY',
}

/**
 * Enum that represents the options that we allow to stop the recurrence
 * @readonly
 * @enum {string} Never | On (date) | After (n ocurrences)
 */
export enum StopRepeatingOptions {
  /** Repeat with no end */
  Never = 'Never',
  /** Repeat until an specific date */
  On = 'On',
  /** Repeat after n ocurrences */
  After = 'After',
}

/**
 * Enum that represents the supported recurrence types
 * @readonly
 * @enum {string} LEGACY | STANDARD | CUSTOM
 */
export enum RecurrenceTypes {
  /** Old recurrence model */
  Legacy = 'LEGACY',
  /** New recurrence standard (suggestions) model */
  Standard = 'STANDARD',
  /** New custom recurrence model */
  Custom = 'CUSTOM',
}

export const STOP_REPEATING = [
  {
    label: StopRepeatingOptions.Never,
    value: StopRepeatingOptions.Never,
  },
  {
    label: StopRepeatingOptions.On,
    value: StopRepeatingOptions.On,
  },
  {
    label: StopRepeatingOptions.After,
    value: StopRepeatingOptions.After,
  },
];

export const PERIODS = [
  {
    label: getPeriodDisplayLabel(PeriodOptions.Weekly),
    value: PeriodOptions.Weekly,
  },
  {
    label: getPeriodDisplayLabel(PeriodOptions.Monthly),
    value: PeriodOptions.Monthly,
  },
  {
    label: getPeriodDisplayLabel(PeriodOptions.Yearly),
    value: PeriodOptions.Yearly,
  },
];

export function getPeriodDisplayLabel(period: string) {
  return startCase(period.substring(0, period.length - 2).toLowerCase());
}

export function formatStringDate(stringDate: string, stringFormat = DATE_FORMAT): string {
  if (!stringDate) return '';
  const date = parseISO(stringDate);
  return format(date, stringFormat);
}

export function ordinal(d: number) {
  return d + (['st', 'nd', 'rd'][(d % 10) - 1] || 'th');
}
